import { render, staticRenderFns } from "./editUserRight.vue?vue&type=template&id=e1347d78&"
import script from "./editUserRight.vue?vue&type=script&lang=js&"
export * from "./editUserRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports